import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { VoucherCancellationBulkCard } from './ui/voucher_cancellation_bulk.js';

export { VoucherCancellationBulkCard } from './ui/voucher_cancellation_bulk.js';

type VoucherCancellationBulkUi = Extract<ChatUi, { kind: 'voucher_cancellation_bulk' }>;

/**
 * O submit com o eco (a fala que a PESSOA aparenta ter dito) já traduzido no
 * idioma da sessão — mesmo padrão do `BusOffersEntry` (#2327): o locale mora no
 * `GenUiConfig`, `render` é uma função de catálogo (hook não roda ali), e um
 * componente resolve sem mover o texto para o card, que segue apresentacional.
 */
function VoucherCancellationBulkEntry({
  ui,
  note,
  readOnly,
  dispatch,
}: Readonly<{
  ui: VoucherCancellationBulkUi;
  note?: string;
  readOnly?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const { t } = useGenUiI18n();
  return (
    <VoucherCancellationBulkCard
      ui={ui}
      note={note}
      readOnly={readOnly}
      onSubmit={
        readOnly
          ? undefined
          : (voucherCodes) => {
              dispatch({
                type: 'interaction',
                interactionId: ui.challengeId,
                text: t('voucherCancelBulk.replySubmit'),
                data: { voucherCodes },
              });
            }
      }
      onQuickReply={
        readOnly
          ? undefined
          : (text) => {
              dispatch({ type: 'reply', text });
            }
      }
    />
  );
}

/**
 * Entrada de catálogo do `voucher_cancellation_bulk` (slot chat). O submit ecoa o
 * `challengeId` ESTRUTURADO (interactionId) MAIS os `voucherCodes` marcados em
 * `data` (→ `confirmation.selections`, canal opaco do shell). O agents re-avalia
 * cada voucher e fence server-side; o texto é só feedback visual.
 */
export const voucherCancellationBulkEntry: GenUiEntry<VoucherCancellationBulkUi> = {
  kind: 'voucher_cancellation_bulk',
  slot: 'chat',
  policy: {
    // Cada reemissão carrega um challenge NOVO e deve aparecer como card
    // acionável no turno atual — reconciliar por id colapsaria sobre a linha
    // antiga, congelada.
    reconcileById: false,
  },
  render: ({ ui, note, readOnly, dispatch }) => (
    <VoucherCancellationBulkEntry
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      dispatch={dispatch}
    />
  ),
};
